class FaqPage extends HTMLElement {
  connectedCallback() {
    this.navButtons = Array.from(this.querySelectorAll('[data-faq-nav]'));
    this.categories = Array.from(this.querySelectorAll('[data-faq-category]'));
    if (!this.navButtons.length || !this.categories.length) return;

    this.navButtons.forEach((button) => {
      button.addEventListener('click', () => this.showCategory(button.dataset.faqNav));
    });

    const hash = window.location.hash.replace(/^#/, '');
    if (hash && this.categories.some((el) => el.dataset.faqCategory === hash)) {
      this.showCategory(hash, { scroll: true });
    }
  }

  showCategory(id, { scroll = false } = {}) {
    this.navButtons.forEach((button) => {
      const active = button.dataset.faqNav === id;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.categories.forEach((section) => {
      const match = section.dataset.faqCategory === id;
      section.hidden = !match;
      if (match && scroll) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    if (history.replaceState) {
      history.replaceState(null, '', `#${id}`);
    }
  }
}

customElements.define('faq-page', FaqPage);
